import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { LogOut, User } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/contexts/AuthContext";
import { projectsApi } from "@/lib/api";

export default function Header() {
  const { user, logout } = useAuth();
  const { projectId } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    if (!projectId) { setProject(null); return; }
    projectsApi.get(projectId).then(setProject).catch(() => setProject(null));
  }, [projectId]);

  return (
    <header
      className="sticky top-0 z-30 h-16 border-b border-border bg-background/85 backdrop-blur-md"
      data-testid="app-header"
    >
      <div className="h-full px-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 min-w-0">
          {project ? (
            <div className="flex items-center gap-3 min-w-0">
              <span className="label-mono text-[10px] text-muted-foreground shrink-0">PROJET</span>
              <h1 className="font-serif font-bold text-lg truncate" data-testid="active-project-name">
                {project.name}
              </h1>
              <span className="hidden md:inline-block label-mono text-[10px] bg-marine/10 text-marine dark:bg-gold/10 dark:text-gold px-2 py-0.5 rounded-sm">
                {project.country} · {project.period_start}–{project.period_end}
              </span>
            </div>
          ) : (
            <span className="label-mono text-[10px] text-muted-foreground">
              L'analyse de la dette au service du citoyen
            </span>
          )}
        </div>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="outline"
                size="sm"
                data-testid="user-menu-trigger"
                className="border-border/60 h-9"
              >
                <User size={14} className="mr-2" />
                <span className="max-w-[120px] truncate">{user?.name || "Compte"}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="font-normal">
                  <div className="text-sm font-medium">{user?.name}</div>
                  <div className="text-xs text-muted-foreground truncate">{user?.email}</div>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem asChild>
                <Link to="/app/projects" data-testid="user-menu-projects">Mes Projets</Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout} data-testid="logout-btn">
                <LogOut size={14} className="mr-2" /> Déconnexion
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
